var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconModalClose = function SvgIconModalClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#DDDEE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 8.7-6.6 6.601M15.3 15.301l-6.6-6.6",
    stroke: "#A4A7AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12ZM12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5Z",
    fill: "#DDDEE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.167 8.292a.74.74 0 0 1 1.047 0l2.736 2.736 2.736-2.736a.74.74 0 1 1 1.047 1.048l-2.735 2.736 2.735 2.735a.74.74 0 1 1-1.048 1.048l-2.735-2.736-2.735 2.736a.74.74 0 0 1-1.048-1.048l2.736-2.735L8.167 9.34a.74.74 0 0 1 0-1.048Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconModalClose;